import React from 'react';

const MultilineText = ({ text, ...props }) => (
  <p {...props}>
    {text && text.split('\n').map((l, i) => <span key={i}>{l}<br /></span>)}
  </p>
);

export default MultilineText;